import React, { Component } from "react";
import { Link, Redirect } from 'react-router-dom';
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import $ from "jquery";

import PROMO_A from "../../../assets/images/promo-a.png";
import PROMO_New from "../../../assets/images/promo-a-new.png";
import PROMO_B from "../../../assets/images/promo-b.png";
import PROMO_C from "../../../assets/images/promo-c.png";

import {
  COMPANY_NAME,
  LOGO,
  THEME_COLOR,
  APP_URL,
  FOOTER_SIGNATURE,
} from "../../../config/config";

import {
  setNewPassword,
  checkForgotVerificationLink,
} from "../../../config/api_calls";

import ImgError from "../../../assets/images/error-404.svg";

import { ValidateEmail, axiosConfig } from "../../../config/utility";
import PasswordStrengthBar from "react-password-strength-bar";
import { useJwt, isExpired, decodeToken } from "react-jwt";

export default class PasswordSetting extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
      confirm_password: "",
      errorPass: "",
      errorConfirmPass: "",
      errorMessage: "",
      disabled: false,
      loader: "",
      successMessage: "",
      tokenExpired: false,
      pageError: "",
      verification_link: "",
      passwordShown: false,
      confirmPasswordShown: false,
      domain_identifier: "",
    };
  }

  componentDidMount = async () => {
    const verification_link = window.location.href;
    this.setState({ loader: "checking", verification_link: verification_link });
    await this.checkVerificationLink(verification_link);
    let isMyTokenExpired = isExpired(this.props.match.params.token_code);
    // console.log("isMyTokenExpired: ", isMyTokenExpired);
    if (isMyTokenExpired === true) {
      this.setState({
        tokenExpired: isMyTokenExpired,
        errorMessage: "Your forgot password activation link is expired now.",
      });
    }
    let myDecodedToken = decodeToken(this.props.match.params.token_code);
    // console.log("email: ", myDecodedToken);
  };

  checkVerificationLink = async (verification_link) => {
    const servicesResponce = await checkForgotVerificationLink(
      this.props.match.params.token_code,
      verification_link
    );
    // console.log("servicesResponce.data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
    } else if (servicesResponce.data.status === 409) {
      this.setState({
        pageError: "This invitation link is no longer valid.",
        errorMessage: "",
        successMessage: "",
        loader: "",
        domain_identifier: servicesResponce.data.reseller_domain_identifier,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        pageError: "",
        errorMessage: "",
        successMessage: "",
        loader: "",
        domain_identifier: servicesResponce.data.reseller_domain_identifier,
      });
    }
  };

  handleChange = (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  formSubmit = async () => {
    const { password, confirm_password, verification_link } = this.state;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (password === "") {
      return this.setState({
        errorPass: "error",
        errorMessage: "Password is required.",
      });
    } else if (password !== "" && !passwordRegex.test(password)) {
      return this.setState({
        errorPass: "error",
        errorMessage:
          "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
      });
    } else if (confirm_password === "") {
      return this.setState({
        errorPass: "",
        errorConfirmPass: "error",
        errorMessage: "Confirm password is required.",
      });
    } else if (password !== confirm_password) {
      return this.setState({
        errorPass: "",
        errorConfirmPass: "error",
        errorMessage: "Password & confirm password not match",
      });
    } else {
      this.setState({
        errorPass: "",
        errorConfirmPass: "",
        errorMessage: "",
        disabled: true,
      });
      let myDecodedToken = decodeToken(this.props.match.params.token_code);

      // console.log("password: ", password);
      let postSetPass = await setNewPassword(
        myDecodedToken.email,
        password,
        this.props.match.params.token_code,
        verification_link
      );
      // console.log("postSetPass: ", postSetPass.data);
      if (
        postSetPass.data.status === 200 &&
        postSetPass.data.message === "Success"
      ) {
        let adminIdentifier = "";
        if (
          Array.isArray(postSetPass.data.adminIdentifier) &&
          postSetPass.data.adminIdentifier.length > 0
        ) {
          adminIdentifier =
            postSetPass.data.adminIdentifier[0].reseller_domain_identifier;
        }
        this.setState({
          successMessage: "Your new password is successfully set",
          errorMessage: "",
        });
        setTimeout(() => {
          window.location.replace(adminIdentifier + "/agent/login");
        }, 2000);
      } else if (
        postSetPass.data.status === 404 ||
        postSetPass.data.errors === "Invalid User"
      ) {
        this.setState({
          successMessage: "",
          errorMessage: "Your account is currently inactive.",
          disabled: false,
        });
      } else if (
        (postSetPass.data.status === 403 &&
          postSetPass.data.errors === "authentication missing") ||
        postSetPass.data.errors === "jwt expired"
      ) {
        this.setState({
          successMessage: "",
          errorMessage: "Your forgot password activation link is expired now.",
          disabled: false,
        });
      }
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  render() {
    return (
      <div className="nk-body npc-crypto ui-clean pg-auth">
        <div className="nk-app-root">
          {this.state.loader === "checking" ? null : this.state.pageError !==
            "" ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                flexDirection: "column",
                textAlign: "center",
                padding: "20px",
              }}
            >
              <img className="nk-error-gfx" src={ImgError} alt="404 error" />
              <h3
                style={{
                  fontSize: "24px",
                  marginBottom: "10px",
                  color: "#1e293b",
                }}
              >
                Oops! Why you’re here?
              </h3>
              <p
                style={{
                  fontSize: "16px",
                  color: "#64748b",
                  marginBottom: "3rem",
                }}
              >
                {this.state.pageError}
              </p>
              <a
                href={`${this.state.domain_identifier}/agent/login`}
                className="btn btn-lg mt-2"
                style={{
                  backgroundColor: THEME_COLOR,
                  color: "white",
                }}
              >
                Back To Home
              </a>
            </div>
          ) : (
            <>
              <div className="nk-split nk-split-page nk-split-md">
                <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container">
                  <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                    <a
                      href="#"
                      className="toggle btn-white btn btn-icon btn-light"
                      data-target="athPromo"
                    >
                      <em className="icon ni ni-info"></em>
                    </a>
                  </div>
                  <div
                    className="nk-block nk-block-middle nk-auth-body"
                    style={{ marginRight: "auto" }}
                  >
                    <div className="brand-logo pb-5 text-center">
                      <a href="/" className="logo-link">
                        <img
                          className="logo-light logo-img logo-img-lg"
                          src={LOGO}
                          alt="logo"
                        />
                        <img
                          className="logo-dark logo-img logo-img-lg"
                          src={LOGO}
                          alt="logo-dark"
                        />
                      </a>
                    </div>
                    <div className="nk-block-head">
                      <div className="nk-block-head-content">
                        <h5 className="nk-block-title">
                          {this.state.tokenExpired === false
                            ? "Change Your Password"
                            : "Link Expired"}
                        </h5>
                        <br />
                        {this.state.tokenExpired === false ? (
                          <p>
                            Please enter your new password and confirm it by
                            entering it again in the 'Confirm Password' field.
                            Once both fields match, click 'Save' to update your
                            password.
                          </p>
                        ) : null}
                        <br />
                        <div className="nk-block-des">
                          {this.state.errorMessage !== "" ? (
                            <div className="example-alert">
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {this.state.successMessage !== "" ? (
                            <div className="example-alert">
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <br />
                        </div>
                      </div>
                    </div>

                    {this.state.tokenExpired === false ? (
                      <div>
                        <div className="form-group">
                          <div className="form-label-group">
                            <label className="form-label" htmlFor="password">
                              Password
                            </label>
                          </div>
                          <div className="form-control-wrap">
                            <input
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              className={
                                "form-control form-control-lg " +
                                this.state.errorPass
                              }
                              id="password"
                              name="password"
                              onChange={this.handleChange}
                              value={this.state.password}
                              placeholder="Enter your password"
                            />
                            <a
                              style={{
                                cursor: "pointer",
                                position: "absolute",
                                top: "22px",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.togglePassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "45px",
                                left: "1px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Password must be at least 8 characters, with
                              uppercase, lowercase, number & special character.
                            </small>
                            <div
                              style={{
                                marginTop: "50px",
                              }}
                            >
                              <PasswordStrengthBar
                                password={this.state.password}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="form-label-group">
                            <label className="form-label" htmlFor="password">
                              Confirm Password
                            </label>
                          </div>
                          <div className="form-control-wrap">
                            <input
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              className={
                                "form-control form-control-lg " +
                                this.state.errorConfirmPass
                              }
                              id="confirm_password"
                              name="confirm_password"
                              onChange={this.handleChange}
                              value={this.state.confirm_password}
                              placeholder="Confirm your password"
                            />
                            <a
                              style={{
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.toggleConfirmPassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                          </div>
                        </div>{" "}
                        <div className="form-group">
                          <button
                            className="btn btn-lg btn-block"
                            onClick={() => this.formSubmit()}
                            disabled={this.state.disabled}
                            style={{
                              backgroundColor: THEME_COLOR,
                              color: "white",
                            }}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="nk-block nk-auth-footer">
                    <div className="text-center">
                      <p>{FOOTER_SIGNATURE}</p>
                      <div>
                        <a
                          href={`${APP_URL}pages/privacyPolicy`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-underline"
                        >
                          Privacy Policy
                        </a>
                        <span className="mx-2">|</span>
                        <a
                          href={`${APP_URL}pages/terms-of-service`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-underline"
                        >
                          Terms of Service
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right"
                  data-content="athPromo"
                  data-toggle-screen="lg"
                  data-toggle-overlay="true"
                >
                  <div className="slider-wrap w-100 w-max-550px p-3 p-sm-5 m-auto">
                    <div
                      className="slider-init"
                      data-slick='{"dots":false, "arrows":false}'
                    >
                      <div className="nk-feature nk-feature-center">
                        <div className="nk-feature-img">
                          <img className="round" src={PROMO_New} alt="" />
                        </div>
                        <div className="nk-feature-content py-4 p-sm-5">
                          <h4>{COMPANY_NAME}</h4>
                          <p>
                            You can start to create your products easily with
                            its user-friendly design & most completed responsive
                            layout.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
